import { render } from "./LockerButton.vue?vue&type=template&id=7ddcf565&scoped=true"
import script from "./LockerButton.vue?vue&type=script&lang=js"
export * from "./LockerButton.vue?vue&type=script&lang=js"

import "./LockerButton.vue?vue&type=style&index=0&id=7ddcf565&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddcf565"]])

export default __exports__